"use client";

import { Banner } from "@/app/components/Banner";
import ServiceContent from "@/app/components/ServiceContent";
import { projectDesignImg } from "@/assets/imgs";

import { useTranslations } from "next-intl";

const ProjectDesign = () => {
  const t = useTranslations();
  return (
    <>
      <Banner
        subUrl={t("links.services")}
        name={t("links.projectDesign")}
        description={t("projectDesign.bannerDescription")}
        className="bg-projectDesign"
      />
      <ServiceContent
        title={t("links.projectDesign")}
        header={t("projectDesign.header")}
        subContent={t("projectDesign.subTitle")}
        content={t("projectDesign.content")}
        img={projectDesignImg}
      />
    </>
  );
};

export default ProjectDesign;
